import gql from 'graphql-tag';

/**
 * Mutation to resolve review reports.
 */
export const RESOLVE_REVIEW_REPORTS_MUTATION = gql`
  mutation($ids: [ID]!) {
    resolveReviewReports(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to dismiss review reports.
 */
export const DISMISS_REVIEW_REPORTS_MUTATION = gql`
  mutation($ids: [ID]!) {
    dismissReviewReports(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;
